module.exports = __webpack_public_path__ + "static/media/IconMarkerBranch.1d19fc40.png";